import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys } from "./query-keys";

/** GET /v1/promotion-groups/{group_id} — every promotion sharing a linked draft group. */
export function useLinkedGroup(groupId: string | null) {
  return useQuery({
    queryKey: [...promotionKeys.all, "linked-group", groupId] as const,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotion-groups/{group_id}", {
        params: { path: { group_id: groupId as string } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    enabled: groupId !== null,
  });
}
